import React from "react";
import PropTypes from "prop-types";
import { H1, H2, H3, H4 } from "theme/components/atoms/Typography/Heading";

/**
 *
 * @typedef {PropTypes.InferProps<typeof propTypes>} HeadingProps
 *
 * @type {import("react").FC<HeadingProps>}
 */
const Heading = ({ children, data, "data-pb-style": styleId }) => {
  const styled = (Component) => {
    return (props) => <Component {...props} data-pb-style={styleId} />;
  };

  switch (data.level) {
    case "h1":
      return <H1 as={styled("h1")}>{children}</H1>;
    case "h2":
      return <H2 as={styled("h2")}>{children}</H2>;
    case "h3":
      return <H3 as={styled("h3")}>{children}</H3>;
    case "h4":
      return <H4 as={styled("h4")}>{children}</H4>;
    case "h5":
      return <H4 as={styled("h5")}>{children}</H4>;
    default:
      return <H4 as={styled("h6")}>{children}</H4>;
  }
};

const propTypes = {
  data: PropTypes.shape({
    level: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]).isRequired,
  }),
  "data-pb-style": PropTypes.string,
};

Heading.propTypes = propTypes;

export default Heading;
